import { render } from "./userAvatar.vue?vue&type=template&id=76cc43fe&ts=true"
import script from "./userAvatar.vue?vue&type=script&lang=tsx"
export * from "./userAvatar.vue?vue&type=script&lang=tsx"

import exportComponent from "C:\\code\\webapp\\postcard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__